import { createFileRoute, redirect } from "@tanstack/react-router";

/** The shop became part of the offer (ADR 0035): old links and bookmarks land on its products. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders
export const Route = createFileRoute("/(private)/shop/")({
  beforeLoad: () => {
    throw redirect({ to: "/offer/products", replace: true });
  },
});
